import React from "react";
import { useNavigate } from "react-router";
import styled from "styled-components";
import comingSoonLogo from "../../assets/images/Coming soon logo.svg";

const ComingSoonPage = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate("/");
  };

  return (
    <ComingSoonWrapper>
      <ComingSoonContent>
        <h1 className="sr-only">Under construction</h1>
        <ConstructionImage
          src={comingSoonLogo}
          alt="Under construction"
        />

        <Message>
          This page is currently under construction. We are working to make it
          available as soon as possible.
          <br />
          Please visit again later for updates.
        </Message>

        <GoBackButton type="button" onClick={handleGoBack}>
          Go Back
        </GoBackButton>
      </ComingSoonContent>
    </ComingSoonWrapper>
  );
};

const ComingSoonWrapper = styled.main`
  min-height: 100vh;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
`;

const ComingSoonContent = styled.section`
  width: min(760px, 100%);
  text-align: center;
`;

const ConstructionImage = styled.img`
  width: min(330px, 80vw);
  height: auto;
  margin: 0 auto 34px;
  display: block;
`;

const Message = styled.p`
  color: #111111;
  font-size: 15px;
  line-height: 1.4;
  margin: 0 auto 36px;
`;

const GoBackButton = styled.button`
  min-width: 122px;
  min-height: 36px;
  border: 0;
  border-radius: 999px;
  background: #00615d;
  color: #ffffff;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  padding: 9px 24px;

  &:hover {
    background: #004f4b;
  }

  &:focus-visible {
    outline: 3px solid rgba(0, 97, 93, 0.25);
    outline-offset: 3px;
  }
`;

export default ComingSoonPage;
